symbolWinBorderAnim = {};
symbolWinBorderAnim.reels = 5;
symbolWinBorderAnim.row = 3;
symbolWinBorderAnim.data = [];
symbolWinBorderAnim.callback;

symbolWinBorderAnim.create = function (json) {
  return new PIXI.Container();
};

symbolWinBorderAnim.initialise = function (json, container, resources) {
  symbolWinBorderAnim.container = container;

  for (var i = 0; i < symbolWinBorderAnim.reels; i++) {
    var rowList = [];

    for (var j = 0; j < symbolWinBorderAnim.row; j++) {
      var symbol = {};
      symbol.animation = resourceManager.createObject(
        "movie",
        "symbolBorderAnim_" + i + "_" + j,
        symbolWinBorderAnim.container,
        { definition: "symbolWin", x: 0, y: 0, loop: false, scale: 1.88 }
      );
      symbol.animation.gotoAndStop(0);
      symbol.animation.visible = false;
      rowList.push(symbol);
    }
    symbolWinBorderAnim.data.push(rowList);
  }

  messageBus.subscribe(
    "spinner:GameConfigEvent",
    symbolWinBorderAnim.onLayoutComplete
  );
};

symbolWinBorderAnim.onLayoutComplete = function () {
  Reflex.registerEventHandler(
    "orientationChange",
    symbolWinBorderAnim.onOrientationChange
  );
};

symbolWinBorderAnim.playAnimation = function (sequence, callback) {
  symbolWinBorderAnim.callback = callback;

  for (var i = 0; i < sequence.data.length; i++) {
    var reel = sequence.data[i].reel;
    var row = sequence.data[i].row;
    var xPos = gameData.reels[reel].position.getX() - 12;
    var yPos = gameData.reels[reel].position.getY() + row * 180;

    symbolWinBorderAnim.data[reel][row].animation.position.set(xPos, yPos);
    symbolWinBorderAnim.data[reel][row].animation.visible = true;
    symbolWinBorderAnim.data[reel][row].animation.play();
  }

  Reflex.addToUpdate(symbolWinBorderAnim.update);
};

symbolWinBorderAnim.onOrientationChange = function () {
  for (var i = 0; i < symbolWinBorderAnim.reels; i++) {
    for (var j = 0; j < symbolWinBorderAnim.row; j++) {
      var reel = i;
      var row = j;
      var xPos = gameData.reels[reel].position.getX() - 12;
      var yPos = gameData.reels[reel].position.getY() + row * 180;

      symbolWinBorderAnim.data[reel][row].animation.position.set(xPos, yPos);
    }
  }
};

symbolWinBorderAnim.stopAllAnimations = function () {
  for (var i = 0; i < symbolWinBorderAnim.reels; i++) {
    for (var j = 0; j < symbolWinBorderAnim.row; j++) {
      symbolWinBorderAnim.data[i][j].animation.visible = false;
      symbolWinBorderAnim.data[i][j].animation.gotoAndStop(0);
    }
  }

  Reflex.removeFromUpdate(symbolWinBorderAnim.update);
  symbolWinBorderAnim.callback();
};

symbolWinBorderAnim.update = function () {
  var allAnimationsEnded = true;

  for (var reel = 0; reel < symbolWinBorderAnim.data.length; reel++) {
    for (var row = 0; row < symbolWinBorderAnim.data[reel].length; row++) {
      if (symbolWinBorderAnim.data[reel][row].animation.playing) {
        allAnimationsEnded = false;
      }
    }
  }

  if (allAnimationsEnded) {
    symbolWinBorderAnim.stopAllAnimations();
  }
};

symbolWinBorderAnim.getFilesRequired = function (json) {
  return [];
};

resourceManager.registerObjectType(
  "symbolWinBorderAnim",
  symbolWinBorderAnim.create,
  symbolWinBorderAnim.initialise,
  symbolWinBorderAnim.getFilesRequired
);
